import { Injectable, inject } from '@angular/core';
import { DropBoxCount, NotificationsService, RealProperty } from '@eemo/api-client';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationCheckService {
  private notificationService = inject(NotificationsService);
  private authService = inject(AuthenticationService);

  private lastNotificationCount = -1;
  private lastGlobalDropboxCount = -1;
  private lastSharingRequestCount = -1;
  private lastPendingVisitFeedbackCount = -1;
  private interval: NodeJS.Timeout;
  public dropBoxCount: BehaviorSubject<DropBoxCount> = new BehaviorSubject<DropBoxCount>(null);
  public notificationCount: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public sharingRequestCount: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public pendingVisitFeedbackCount: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor() {
    const authService = this.authService;

    authService.currentUserSubject.subscribe((user) => {
      if (user != null) {
        this.loadData();
        this._scheduleCheck();
      } else {
        this._deleteScheduledCheck();
      }
    });
  }

  private _scheduleCheck() {
    this.interval = setInterval(() => {
      this.loadData();
    }, environment.notificationCheckFrequency * 1000);
  }

  private _deleteScheduledCheck() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  public loadData() {
    this.notificationService.getNewNotificationsCount().subscribe((data) => {
      if (this.lastNotificationCount != data.count) {
        // notification count update detected
        this.notificationCount.next(data.count);
        this.lastNotificationCount = data.count;
      }
      if (this.lastGlobalDropboxCount != data.dropbox.global) {
        // dropbox count update detected
        this.dropBoxCount.next(data.dropbox);
        this.lastGlobalDropboxCount = data.dropbox.global;
      }
      if (this.lastSharingRequestCount != data.shareRequestCount) {
        // sharing request count update detected
        this.sharingRequestCount.next(data.shareRequestCount);
        this.lastSharingRequestCount = data.shareRequestCount;
      }
      if (this.lastPendingVisitFeedbackCount != data.pendingVisitFeedbackCount) {
        // pending visit feedback count update detected
        this.pendingVisitFeedbackCount.next(data.pendingVisitFeedbackCount);
        this.lastPendingVisitFeedbackCount = data.pendingVisitFeedbackCount;
      }
    });
  }

  public decreaseNotification(): void {
    let count = this.notificationCount.getValue();
    count--;
    this.notificationCount.next(count);
  }

  public decreaseDropboxDoc(prop: RealProperty): void {
    const cur = this.dropBoxCount.getValue();
    cur.global--;
    cur.details.forEach((dp) => {
      if (dp.property.uid === prop.uid) {
        dp.count--;
      }
    });
  }
}
